export default __webpack_public_path__ + "static/media/TS2.fc8b1a02.png";